module.exports = __webpack_public_path__ + "img/idea.738d3c96.svg";